"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectValue = void 0;
var react_1 = __importStar(require("react"));
var SelectValue = function (props) {
    var option = props.option, onOptionSelect = props.onOptionSelect, spanProps = __rest(props, ["option", "onOptionSelect"]);
    var toRender;
    if (option.label) {
        toRender = option.label;
    }
    else if (react_1.isValidElement(option.item)) {
        // If item can be rendered, then prefer that
        toRender = option.item;
    }
    else if (typeof option.value === "string" ||
        typeof option.value === "number" ||
        react_1.isValidElement(option.value)) {
        // Otherwise fall back to value
        toRender = option.value;
    }
    else {
        toRender = "No renderable value";
    }
    return (react_1.default.createElement("span", __assign({}, spanProps, { onClick: function (e) {
            spanProps.onClick && spanProps.onClick(e);
            onOptionSelect(option);
        } }), toRender));
};
exports.SelectValue = SelectValue;
//# sourceMappingURL=SelectValue.js.map